export default __webpack_public_path__ + "static/media/caloTokenTR.69608b58.png";